jQuery(function ($) {
  "use strict";

  var init = [
    function () {
      if ($('.scroll-to-top').length) {
        let mybutton = document.getElementById("btn-back-to-top");

        // When the user scrolls down 150px from the top of the document, show the button
        window.onscroll = function () {
          scrollFunction();
        };

        function scrollFunction() {
          if (
            document.body.scrollTop > 150 ||
            document.documentElement.scrollTop > 150
          ) {
            mybutton.style.display = "block";
          } else {
            mybutton.style.display = "none";
          }
        }
        // When the user clicks on the button, scroll to the top of the document
        mybutton.addEventListener("click", backToTop);

        function backToTop() {
          document.body.scrollTop = 0;
          document.documentElement.scrollTop = 0;
        }
      } else {}
    },
    function () {
      if ($('.main-navigation .main-navigation__search .site-search').length) {
        $(".main-navigation .main-navigation__search .site-search").click(function(){
          $(".main-navigation .main-navigation__search .search-form").toggle();
        });
      }
    },
    function () {
      $(document).ready(function() {
        var modalInner = $('.modal__inner');
        modalInner.each(function() {
          var content = $(this);
          $(this).remove();
          $('.entry-content').append(content);
        });
      });
    },
      function () {
      new WOW(
        {
          boxClass:     'wp-block-column',
          animateClass: 'fadeIn',
          offset:       0,
          mobile:       false,
          live:         true,
        }
      ).init();
    },
    function () {
      new WOW(
        {
          boxClass:     'wp-block-cover__inner-container',
          animateClass: 'fadeInUp',
          offset:       0,
          mobile:       false,
          live:         true,
        },
      ).init();
    },
    function () {
      $(window).on('load', function menuStuff() {
        var headerHeight = $('.site-header').outerHeight();
        var body = $('body');
        var sticky = $('.site-header');
        let menu = $('#menu');
        let nav = $('.main-navigation__nav');

        // Function to handle sticky header
        function handleStickyHeader() {
          var scroll = $(window).scrollTop();

          if (scroll >= headerHeight + 10) {
            sticky.addClass('site-header--sticky');
            body.css('padding-top', headerHeight);
          } else {
            sticky.removeClass('site-header--sticky');
            body.css('padding-top', 0);
          }
        }

        // Function to add or remove buttons based on viewport size
        function handleResponsiveMenu() {
          $('.site-header .menu .menu-item.menu-item-has-children').each(function() {
            if (!$(this).find('.menu-item-dropdown-toggle').length) {
              $(this).append('<button class="menu-item-dropdown-toggle"></button>');
            }
          });
        }

        function positionSubMenu() {
          var subMenus = document.querySelectorAll('.site-header .menu .menu-item.menu-item-has-children .sub-menu');

          subMenus.forEach(function(subMenu) {
            // Temporarily set the sub-menu to be visible
            subMenu.classList.add('sub-menu__active');

            var rect = subMenu.getBoundingClientRect();

            // Check if there's enough space on the right
            if (rect.right > window.innerWidth) {
              subMenu.classList.add('sub-menu--right');
            } else {
              subMenu.classList.remove('sub-menu--right');
            }

            // Hide the sub-menu again
            subMenu.classList.remove('sub-menu__active');
          });
        }

        // Initial call to handleStickyHeader to set the initial state
        handleStickyHeader();
        handleResponsiveMenu();
        positionSubMenu();

        // Bind scroll event to handleStickyHeader
        $(window).scroll(handleStickyHeader);

        // Bind resize event to handleResponsiveMenu
        $(window).resize(handleResponsiveMenu);

        // Bind resize event to positionSubMenu
        $(window).resize(positionSubMenu);

        // Set initial top position for mobile navigation
        $('.site-header .main-navigation .main-navigation__nav').css('top', headerHeight);

        menu.on('click', function(e) {
          $(this).toggleClass('is-open');
          nav.toggleClass('is-open');
        });

        // Toggle sub-menus when the dropdown button is clicked
        $('.site-header .menu .menu-item.menu-item-has-children .menu-item-dropdown-toggle').on('click', function(e) {
          e.preventDefault();
          var subMenu = $(this).siblings('.sub-menu');
          var allDropDowns = $('.menu-item-dropdown-toggle');

          // Close all open sub-menus and remove active class from all dropdown buttons
          $('.sub-menu').not(subMenu).removeClass('sub-menu__active');
          allDropDowns.not($(this)).removeClass('menu-item-dropdown-toggle--active');

          // Toggle active class for the clicked button and its submenu
          $(this).toggleClass('menu-item-dropdown-toggle--active');
          subMenu.toggleClass('sub-menu__active');

          // Disable scrolling on everything else when dropdown is open
          if (subMenu.hasClass('sub-menu__active')) {
            $('body').css('overflow', 'hidden');
          } else {
            $('body').css('overflow', ''); // Enable scrolling when dropdown is closed
          }

          e.stopPropagation(); // Stop the event from bubbling up to the document
        });

        // Close sub-menus when clicking outside of them
        $(document).click(function(e) {
          // Check if the clicked element is not a submenu or its parent button
          if (!$(e.target).closest('.sub-menu').length && !$(e.target).closest('.menu-item-dropdown-toggle').length) {
            // Remove the active class from all submenus and dropdown buttons
            $('.sub-menu').removeClass('sub-menu__active');
            $('.menu-item-dropdown-toggle').removeClass('menu-item-dropdown-toggle--active');

            // Enable scrolling when clicking outside the dropdown
            $('body').css('overflow', ''); // Enable scrolling
          }
        });
      }).init();
    },
    function () {

        const providerSticky = function () {

            $('.provider-wrapper__post').each(function () {

                const $info = $(this).find('.provider__info');
                const $credentials = $(this).find('.provider__credentials');

                $info.removeClass('is-sticky');
                $credentials.removeClass('is-sticky');

                if ($(window).width() < 782) {
                    $info.css('top', '');
                    $credentials.css('top', '');
                    return;
                }

                const infoHeight = $info[0].scrollHeight;
                const credentialsHeight = $credentials[0].scrollHeight;

                let stickyTop = 20;

                if ($('.site-header').hasClass('site-header--sticky')) {
                    stickyTop += $('.site-header').outerHeight();
                }

                if (infoHeight < credentialsHeight) {

                    $info
                        .addClass('is-sticky')
                        .css('top', stickyTop + 'px');

                } else if (credentialsHeight < infoHeight) {

                    $credentials
                        .addClass('is-sticky')
                        .css('top', stickyTop + 'px');

                }

            });

        };

        providerSticky();

        $(window).on('load resize scroll', providerSticky);

    },
    function () {
      // Get a reference to the SVG element
      var svg = $('.think-logo');

      // Function to update viewBox based on viewport size
      function updateViewBox() {
        var width = window.innerWidth;

        // Adjust viewBox based on viewport size
        if (width <= 781) {
          svg.attr('viewBox', '0 0 130.2 50');
        } else {
          svg.attr('viewBox', '0 0 311.6 40');
        }
      }

      // Initial call to set viewBox based on window size
      updateViewBox();

      // Call the function whenever the window is resized
      window.addEventListener('resize', updateViewBox);
    },
    function () {
      var $stickyRow = $('.sticky-row');
      var $stickyRowStop = $('.sticky-row-stop');
      var $stickyRowPlaceholder = $('<div class="sticky-row-placeholder"></div>');

      // Wrap the sticky row with the placeholder
      $stickyRow.wrap($stickyRowPlaceholder);

      // Initially set the height of the placeholder
      $stickyRow.parent().height($stickyRow.outerHeight());

      var originalPos = $stickyRow.offset().top;
      var stopPos = $stickyRowStop.offset().top;
      var menuHeight = $('.site-header').outerHeight();
      var sharer = $('.social-media--sharing').outerHeight();

      var distanceToStop = stopPos - originalPos;

      $(window).scroll(function() {
        var scrollPos = $(window).scrollTop();

        if (scrollPos >= originalPos - menuHeight && scrollPos < stopPos - sharer - menuHeight - 10) {
          $stickyRow.addClass('sticky-row--stuck').removeClass('sticky-row--stopped');
          $stickyRow.css('top', menuHeight + 10);
        } else if (scrollPos >= stopPos - sharer - menuHeight - 10) {
          $stickyRow.removeClass('sticky-row--stuck').addClass('sticky-row--stopped');
          $stickyRow.css('top', distanceToStop - sharer + 'px');
        } else {
          $stickyRow.removeClass('sticky-row--stuck').removeClass('sticky-row--stopped').css('top', '');
        }
      });
    },
    function () {
      $('.wc-forward').each(function() {
        if ($(this).hasClass('button')) {
          $(this).removeClass('button');
        }
      });
    },
  ];

  $.each(init, function (index, initFunction) {
    initFunction();
  });
});